export default function Collaboration() {
  return (
    <>
      <img
        className="mx-auto my-16"
        alt=""
        src={require("../assets/home/collaboration/img01.png")}
      />
    </>
  );
}
